export default "__VITE_ASSET__OoYLhUe6__"